import React from 'react';
import Icon from '@ant-design/icons';

const JCloseCircleSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Close-circle</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-Close-circle" stroke="currentColor">
        <circle id="Oval" cx="8" cy="8" r="7.5" />
        <g
          id="Group"
          transform="translate(5.000000, 5.000000)"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="Icon-/-Close">
            <line
              x1="6.97747564"
              y1="3"
              x2="-0.977475644"
              y2="3"
              id="Path"
              transform="translate(3.000000, 3.000000) rotate(-135.000000) translate(-3.000000, -3.000000) "
            />
            <line
              x1="7.02687364"
              y1="3.04939799"
              x2="-0.92807765"
              y2="3.04939799"
              id="Path"
              transform="translate(3.049398, 3.049398) scale(-1, 1) rotate(-135.000000) translate(-3.049398, -3.049398) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const JCloseCircle: React.FC<any> = ({ className, ...props }) => {
  return (
    <Icon
        aria-hidden={true}
      component={JCloseCircleSVG}
      className={`hover:text-red${className ? ' ' + className : ''}`}
      {...props}
    />
  );
};
